// utils/testConversion.ts

// Google Ads configuration constants
const GOOGLE_ADS_CONFIG = {
  CONVERSION_ID: 'AW-16631687339',
  CONVERSION_LABEL: 'fGJbCNaMrb8ZEKvRzfo9',
  get SEND_TO() {
    return `${this.CONVERSION_ID}/${this.CONVERSION_LABEL}`;
  }
} as const;

export const testGoogleAdsSetup = (): boolean => {
//   if (typeof window === 'undefined') {
//     console.log('❌ Running on server side');
//     return false;
//   }

//   console.log('🔍 Testing Google Ads Setup...');
  
  // Test 1: Check if gtag is loaded
  if (typeof window.gtag === 'function') {
    // console.log('✅ gtag function is available');
  } else {
    // console.log('❌ gtag function not found - scripts may still be loading');
    return false;
  }

  // Test 2: Check dataLayer
//   if (window.dataLayer && Array.isArray(window.dataLayer)) {
//     // console.log('✅ dataLayer is initialized');
//     // console.log('📊 dataLayer contents:', window.dataLayer);
//   } else {
//     console.log('❌ dataLayer not found or not an array');
//   }

  // Test 3: Check conversion function
//   if (typeof window.gtag_report_conversion === 'function') {
//     console.log('✅ gtag_report_conversion function is available');
//   } else {
//     console.log('❌ gtag_report_conversion function not found - may still be loading');
//   }

  // Test 4: Send test conversion (without redirect)
  try {
    window.gtag('event', 'conversion', {
      send_to: GOOGLE_ADS_CONFIG.SEND_TO,
      debug_mode: true
    });
    // console.log('✅ Test conversion event sent');
  } catch (error) {
    console.log('❌ Error sending test conversion:', error instanceof Error ? error.message : String(error));
  }

  return true;
};

// Function untuk test di browser console
// export const debugConversion = (): void => {
//   console.log('=== GOOGLE ADS DEBUG INFO ===');
//   console.log('Window gtag:', typeof window.gtag);
//   console.log('Window gtag_report_conversion:', typeof window.gtag_report_conversion);
//   console.log('DataLayer length:', window.dataLayer?.length || 0);
//   console.log('DataLayer last 5 items:', window.dataLayer?.slice(-5));
  
//   // Check network requests
//   console.log('🌐 To check network requests:');
//   console.log('1. Open DevTools → Network tab');
//   console.log('2. Filter by "gtag" or "google"');
//   console.log('3. Click conversion button');
//   console.log('4. Look for requests to google-analytics.com');
// };

// Type-safe window assignment
const attachToWindow = (): void => {
  if (typeof window !== 'undefined') {
    window.testGoogleAds = testGoogleAdsSetup;
    // window.debugConversion = debugConversion;
  }
};

// Only add to window on client side with proper delay
if (typeof window !== 'undefined') {
  // Wait for scripts to load before attaching to window
  setTimeout(attachToWindow, 2000);
}